import brushIcon from '../images/icons/brush.svg'
import codeIcon from '../images/icons/code.svg'
import rocketIcon from '../images/icons/rocket.svg'
export const processData = [
    {
        icon: codeIcon,
        title: 'Discovery',
        paragraph: 'In this step, we actively learn about the needs and goals of the project and thoroughly discuss various solutions and directions to take.'
    },
    {
        icon: brushIcon,
        title: 'Design',
        paragraph: 'This phase focuses on the creative visual aspect, starting with sketches & wireframes and progressing to the final design of branding or website.'
    },
    {
        icon: codeIcon,
        title: 'Development',
        paragraph: 'This step involves the technical side, including developing the design of the website on the platform or creating sketches for branding.'
    },
    {
        icon: rocketIcon,
        title: 'Launch',
        paragraph: 'The final step includes completing any necessary revisions, user testing, bug fixes, training, and delivering the product to the client.'
    },
]